export const async_google_shopping = {
  asyncType: 'google-shopping',
  hostedScraperType:  'async_google_shopping',
  publicHostedScraperAPIType:  'google_shopping',
  inputKey: 'query',
  inputsKey: 'queries',
  inputJsonSchema: { type: 'string' },
  asyncEndpoint: '/structured/google/shopping',
  apiEndpoint: '/structured/google/shopping',
  apiCostEndpoint: '/account/googleshoppingcost',
  propertiesJsonSchemaPart: {
    output_format: { type: 'string', enum: [ 'csv', 'json' ] },
    tld: { type: 'string' },
    country_code: { type: 'string' },
    uule: { type: 'string' },
    num: { type: 'string' },
    hl: { type: 'string' },
    gl: { type: 'string' },
    ie: { type: 'string' },
    oe: { type: 'string' },
    start: { type: 'string' }
  }
};
